module.exports = __webpack_public_path__ + "static/media/11 12 '04_0c9937ee-ad9d-4448-874a-339a915348c1.73ede0be.png";